import React from 'react'
import MainContentSubAccessories from '../MainContentSubAccessories'

const XiaomiAccessoriesSub = () => {
  return (
    <div className='pageAccessories bg-accessories-sub-page'>
        <MainContentSubAccessories parentCate={'Phụ kiện'}  
            childCate={'Phụ kiện Xiaomi chính hãng'} 
            // listProduct={listProductSub}
    />
</div>
  )
}

export default XiaomiAccessoriesSub
